import { PressTracker } from './pressTracker';
import { Message } from './message';
import { IPlayer } from '../player/model/interfaces';

type waitingMessageType = {
  pid: number | undefined;
  tid: number | undefined;
  text: string;
};

export class Messages {
  private waitings: waitingMessageType[] = [];
  lastSendTime = 0;
  sendCount = 0;
  pressTracker = new PressTracker();

  canSend(me: IPlayer | undefined): boolean {
    if (me && (me.isAdmin() || me.isTD())) {
      return true;
    }

    const now = new Date().getTime();
    if (now - this.lastSendTime < 500) return false; // Не чаще, чем 1 раз в пол секунды
    if (now - this.lastSendTime > 5000) this.sendCount = 0;
    if (this.sendCount++ >= 3) return false; // Не чаще чем 3 раза за 5 секунд
    this.updateLastSend();
    return true;
  }

  private updateLastSend(): void {
    this.lastSendTime = new Date().getTime();
  }

  //recipientId - либо Type (от -2 до -8), либо PlayerId
  //Нет смысла Type передавать!!!!!
  waitEcho(text: string, tid?: number, recipientId?: number): void {
    const textFormat = text.toLowerCase().trim();
    let pid: number | undefined;
    if (recipientId && recipientId >= 0) pid = recipientId;

    let tableId: number | undefined;
    if (tid && tid >= 0) tableId = tid;

    this.waitings.push({
      text: textFormat,
      pid,
      tid: tableId,
    });
  }

  handleEcho(msg: Message): boolean {
    let wait: waitingMessageType | undefined;
    if (this.waitings.length === 0) return false;
    while (this.waitings.length > 0) {
      wait = this.waitings.shift();
      if (wait) {
        if (msg.text.toLowerCase().trim() !== wait.text) continue;
        if (wait.pid !== undefined) msg.recipientId = wait.pid; // Добавление реального получателя...хм...это же эхо, там только мы и это отправитель, а не получатель
        if (wait.tid !== undefined) msg.recipientTableId = wait.tid; // Добавление стола
        return true;
      }
    }
    return false;
  }

  isCommand(text: string) {
    const cmdRegEx = /^\/.+/;
    return cmdRegEx.test(text);
  }

  isValidCommand(text: string) {
    const invalidCmd = /^\/((err)|(ver)|(dbg))$/;
    return !invalidCmd.test(text);
  }
}
